import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainContent from "../components/MainContent";
import { getAvatarUrl } from "../config/users";
import { UserAuth } from "../context/AuthContext";
import "../css/index.css";

// Hardcoded mosaic names - balanced grades (A/B/C/D/F) and lengths (short/medium/long)
const mosaicNames = [
  // A grades - short
  { name: "DAISY", grade: "A" }, { name: "GLAZE", grade: "A" }, { name: "ROTE", grade: "A" }, { name: "PEEL", grade: "A" },
  { name: "SLASH", grade: "A" }, { name: "YUZO", grade: "A" }, { name: "FEELIX", grade: "A" }, { name: "PRISI", grade: "A" },
  { name: "TWAY", grade: "A" }, { name: "ZIYA", grade: "A" }, { name: "AMIR", grade: "A" }, { name: "FLUKE", grade: "A" },
  // A grades - medium
  { name: "SOLRISE", grade: "A" }, { name: "GENECHO", grade: "A" }, { name: "ORDAPATH", grade: "A" }, { name: "STARRY SKY", grade: "A" },
  { name: "REDDIA", grade: "A" }, { name: "BOULDER", grade: "A" }, { name: "AIRBEAR", grade: "A" }, { name: "JERRELL", grade: "A" },
  { name: "REBREEVA", grade: "A" }, { name: "EARTHY", grade: "A" }, { name: "ARMARA", grade: "A" }, { name: "REKREA", grade: "A" },
  // A grades - long
  { name: "CANDYMACHINE", grade: "A" }, { name: "ETERNAL FEAST", grade: "A" }, { name: "ONE BIG WINDOW", grade: "A" }, { name: "LIKEWORTHY", grade: "A" },
  { name: "COPPERHALL", grade: "A" }, { name: "MEMORY MADE", grade: "A" }, { name: "SIP AND SAVOR", grade: "A" }, { name: "COME ALIVE", grade: "A" },
  // B grades - short
  { name: "PERTY", grade: "B" }, { name: "ENTIFI", grade: "B" }, { name: "GIANNA", grade: "B" }, { name: "DAWNS", grade: "B" },
  { name: "SAVORY", grade: "B" }, { name: "ROSE", grade: "B" }, { name: "BOOK", grade: "B" }, { name: "CAPITAL", grade: "B" },
  { name: "TWANG", grade: "B" }, { name: "PILL", grade: "B" }, { name: "CLEAT", grade: "B" }, { name: "KNOCK", grade: "B" },
  // B grades - medium
  { name: "RESURGENT", grade: "B" }, { name: "PROLIFERATE", grade: "B" }, { name: "WELLSPRING", grade: "B" }, { name: "FOOTHILLS", grade: "B" },
  { name: "SOFT LIGHT", grade: "B" }, { name: "PILL POINT", grade: "B" }, { name: "LITERACY", grade: "B" }, { name: "CREATURE", grade: "B" },
  { name: "TWINKLER", grade: "B" }, { name: "ADJUSTER", grade: "B" }, { name: "EXAMINA", grade: "B" }, { name: "JACENT", grade: "B" },
  // B grades - long
  { name: "ROSE COMPASS", grade: "B" }, { name: "FOR ALWAYS", grade: "B" }, { name: "NEW PROTOCOL", grade: "B" }, { name: "BRIGHTLINE", grade: "B" },
  { name: "GREEN SHOOTS", grade: "B" }, { name: "CONTEMPLATED", grade: "B" }, { name: "GOOD GROUND", grade: "B" }, { name: "BITE BAZAAR", grade: "B" },
  // C grades - short
  { name: "CALLER", grade: "C" }, { name: "SOLTERA", grade: "C" }, { name: "EDEMIC", grade: "C" }, { name: "ZODIAC", grade: "C" },
  { name: "ADACIA", grade: "C" }, { name: "CLARE", grade: "C" }, { name: "CHATTER", grade: "C" }, { name: "GEMMA", grade: "C" },
  { name: "SENA", grade: "C" }, { name: "KUMU", grade: "C" }, { name: "KARMAN", grade: "C" }, { name: "REROUTE", grade: "C" },
  // C grades - medium
  { name: "NOVASTREAM", grade: "C" }, { name: "CROSSWORD", grade: "C" }, { name: "DOUGHNUT", grade: "C" }, { name: "AKROFLOW", grade: "C" },
  { name: "MOUNTAYO", grade: "C" }, { name: "RIGHTON", grade: "C" }, { name: "NETFLOW", grade: "C" }, { name: "WATCH FACE", grade: "C" },
  { name: "CULTURE CLUB", grade: "C" }, { name: "VIBRITE", grade: "C" }, { name: "GRAFTA", grade: "C" }, { name: "GALORE", grade: "C" },
  // C grades - long
  { name: "SPACE STATION", grade: "C" }, { name: "ATOMIC LANE", grade: "C" }, { name: "ALPINE STATE", grade: "C" }, { name: "STREAMLINK", grade: "C" },
  { name: "TWO AND ONE", grade: "C" }, { name: "WATERSPOUT", grade: "C" }, { name: "PAINT THE TOWN", grade: "C" }, { name: "DYNASTREAM", grade: "C" },
  // D grades - short
  { name: "TOLLA", grade: "D" }, { name: "LUMI", grade: "D" }, { name: "TEETH", grade: "D" }, { name: "SPECULAR", grade: "D" },
  { name: "HIFIGURE", grade: "D" }, { name: "PILLOW", grade: "D" }, { name: "MENTAL", grade: "D" }, { name: "LONGSIDE", grade: "D" },
  { name: "AFFOLD", grade: "D" }, { name: "UNITION", grade: "D" }, { name: "SMARA", grade: "D" }, { name: "JAIRO", grade: "D" },
  // D grades - medium
  { name: "ON SITE", grade: "D" }, { name: "BLOOPER", grade: "D" }, { name: "TALKSHOW", grade: "D" }, { name: "VICTORIA", grade: "D" },
  { name: "WHISPER", grade: "D" }, { name: "SPITZE", grade: "D" }, { name: "YOUNG MUSE", grade: "D" }, { name: "LAYER UP", grade: "D" },
  { name: "MOODRAY", grade: "D" }, { name: "BANNER", grade: "D" }, { name: "PRIMAPULSE", grade: "D" }, { name: "DARAI", grade: "D" },
  // D grades - long
  { name: "OUTTA HERE", grade: "D" }, { name: "DROP ZONE", grade: "D" }, { name: "DREAMWIRE", grade: "D" }, { name: "FULL HOUSE", grade: "D" },
  { name: "TIMECAPSULE", grade: "D" }, { name: "BRIGHTBUSH", grade: "D" }, { name: "MASTERFLOW", grade: "D" }, { name: "WATCH FACE", grade: "D" },
  // F grades - short
  { name: "DAISY", grade: "F" }, { name: "PEEL", grade: "F" }, { name: "LULURE", grade: "F" }, { name: "BREEZY", grade: "F" },
  { name: "ESSIUS", grade: "F" }, { name: "WHIFF!", grade: "F" }, { name: "TAG TEAM", grade: "F" }, { name: "VESPER", grade: "F" },
  { name: "INEVITABLE", grade: "F" }, { name: "DYNAFLOW", grade: "F" }, { name: "PILSON", grade: "F" }, { name: "HOODLE", grade: "F" },
  // F grades - medium
  { name: "NOVASTREAM", grade: "F" }, { name: "AKROFLOW", grade: "F" }, { name: "GLIMMER", grade: "F" }, { name: "EYE-TO-EYE", grade: "F" },
  { name: "MINDER", grade: "F" }, { name: "FOOTHILLS", grade: "F" }, { name: "LUMASTREAM", grade: "F" }, { name: "CLEARDAY", grade: "F" },
  { name: "HYPERLINK", grade: "F" }, { name: "STREAKY", grade: "F" }, { name: "MONOWAVE", grade: "F" }, { name: "METAWELL", grade: "F" },
  // F grades - long
  { name: "WIDE WORLD", grade: "F" }, { name: "INTERNAL S...", grade: "F" }, { name: "ONOMATOP...", grade: "F" }, { name: "VOWEL REM...", grade: "F" },
  { name: "NEW MUSIC...", grade: "F" }, { name: "OBJECT AB...", grade: "F" }, { name: "SUFFIXER", grade: "F" }, { name: "WORD SPLIT", grade: "F" },
  // Extra fill
  { name: "SUNFLOWER", grade: "A" }, { name: "EXPANDER", grade: "B" }, { name: "KAIKAN", grade: "C" }, { name: "SPACESUIT", grade: "D" },
  { name: "CADDY", grade: "A" }, { name: "TWENTY", grade: "B" }, { name: "COFACTOR", grade: "C" }, { name: "JUBUL", grade: "D" },
  { name: "TREETOPS", grade: "A" }, { name: "HEAVILY", grade: "B" }, { name: "GURNY", grade: "C" }, { name: "COMMANDEER", grade: "D" },
  { name: "CALL", grade: "A" }, { name: "OXYMORONS", grade: "B" }, { name: "EXAMINA", grade: "C" }, { name: "TREADLORD", grade: "D" },
  { name: "POSTLAYER", grade: "A" }, { name: "YIKES", grade: "B" }, { name: "ANAGRAM", grade: "C" }, { name: "COMPOUNDS", grade: "D" },
  { name: "PLACENAME", grade: "A" }, { name: "FIND NOUNS", grade: "B" }, { name: "PURALIZE", grade: "C" }, { name: "SANCTUM", grade: "D" },
  { name: "AETHEREAL", grade: "A" }, { name: "ASSUMING", grade: "B" }, { name: "BEBBLE", grade: "C" }, { name: "LOADCAST", grade: "D" },
  { name: "DARTBOARD", grade: "A" }, { name: "BIG WIDE", grade: "B" }, { name: "CHUCKITS", grade: "C" }, { name: "CLEAT", grade: "D" },
  { name: "CAELA", grade: "A" }, { name: "WEARADAY", grade: "B" }, { name: "REVELATORY", grade: "C" }, { name: "TENDLY", grade: "D" },
  { name: "MANY MIND", grade: "A" }, { name: "CLAY MILL", grade: "B" }, { name: "SALUTATION", grade: "C" }, { name: "AIRBORN", grade: "D" },
  { name: "UPSCALE", grade: "A" }, { name: "CONVEY", grade: "B" }, { name: "ONESHIP", grade: "C" }, { name: "KLEISTER", grade: "D" },
  { name: "MILAGE", grade: "A" }, { name: "FATE", grade: "B" }, { name: "FLARE", grade: "C" }, { name: "AMULETIC", grade: "D" },
  { name: "LIGHTRIFT", grade: "A" }, { name: "BLUFF", grade: "B" }, { name: "BOURNES", grade: "C" }, { name: "SAWHILL", grade: "D" },
].map((n, i) => ({ ...n, uniqueId: `name-${i}` }));

// Shuffle once at load
const shuffledNames = [...mosaicNames].sort(() => 0.5 - Math.random());

function App() {
  const { user, logOut } = UserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null) {
      navigate("/signin");
    }
  }, [user, navigate]);

  if (!user?.email) {
    return null;
  }

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  const getCustomAvatar = () => {
    return getAvatarUrl(user.email, user.photoURL) || "/default-avatar.jpg";
  };

  const gradeColors = {
    A: "text-success",
    B: "text-info",
    C: "text-warning",
    D: "text-error",
    F: "text-error",
  };

  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center overflow-hidden relative">
      {/* Mosaic grid background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-10 lg:grid-cols-12 gap-px bg-base-content/5">
          {shuffledNames.map((name, i) => (
            <div
              key={name.uniqueId || i}
              className="mosaic-tile bg-base-100 p-2 flex items-center justify-center min-h-[60px]"
              style={{
                animationDelay: `${i * 15}ms`,
              }}
            >
              <div className="text-center">
                <span className="font-[Oswald] font-semibold uppercase tracking-tight text-xs text-base-content/70 block truncate max-w-[80px]">
                  {name.name}
                </span>
                {name.grade && (
                  <span className={`text-[9px] font-bold ${gradeColors[name.grade] || 'text-base-content/40'}`}>
                    {name.grade}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Center box - responsive */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-base-100 border border-base-content/10 rounded-lg pointer-events-none
        w-[90vw] h-[85vh] max-w-[820px] max-h-[460px]
        md:w-[800px] md:h-[420px]"
      />

      {/* Main content */}
      <MainContent user={user} handleSignOut={handleSignOut} getCustomAvatar={getCustomAvatar} />

      {/* Fade in animation */}
      <style>{`
        @keyframes mosaic-fade-in {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: var(--final-opacity); transform: scale(1); }
        }
        .mosaic-tile {
          animation: mosaic-fade-in 0.4s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </div>
  );
}

export default App;
